import { DEL_ERR,DELETE_BTN_CONTAINER_STYLE, DELETE_PART, MARGIN_10PX } from "../../utils/constants/GlobalConstants";
import ButtonLayout from "../common/button/ButtonLayout";
import { deleteQuantityPart } from "../../services/partServices";

const DeleteFunctionality = (props) => {

  const deleteConfirmed = async () => {
    const deleteRecord = props.partRows?.find(item => item.partNumber === props.selectedPart);
    try {
      const response = await deleteQuantityPart(deleteRecord.id);
      if (response?.id) {
        const req = { id: response?.id };
        props.partModied(req, DELETE_PART);
        props.cancelClicked()
      } else {
        console.log('delete part failed');
      }
    } catch (error) {
      console.error(error);
    }
  }
  const deleteConfirmedDebi = () => {
    props.deleteClicked();
  }
  return (
    <>
       <div>{DEL_ERR} </div>
      <div style={DELETE_BTN_CONTAINER_STYLE}>
        <ButtonLayout testid="cancel" label="Cancel" style={MARGIN_10PX} onClickBtn={() => props.cancelClicked()} />&nbsp; &nbsp;
        <ButtonLayout label="Delete" style={MARGIN_10PX} onClickBtn={props?.debiDelete ? deleteConfirmedDebi : deleteConfirmed} testid="delete-btn" />
      </div>
    </>
  );
};
export default DeleteFunctionality;
